import { AxiosRequestConfig } from 'axios';
import { api } from './api';

export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  const url = config.url?.startsWith('/api/v1')
    ? config.url.substring('/api/v1'.length)
    : config.url;

  return api({
    ...config,
    url,
    ...options,
  }).then((r) => r.data);
};
